import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetSportClubs } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { sportClubsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfSportClubContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentClubs = useAppSelector(sportClubsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().sportClubs });

  const hasData = studentClubs.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentClubs, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Клубы и команды" Icon={IconWidgetSportClubs}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfSportClubContainer;
